import type { IconType } from 'react-icons'
import {
  PiFilePdf,
  PiFilePng,
  PiFileJpg,
  PiFileImage,
  PiFileDoc,
  PiFileXls,
  PiFilePpt,
  PiFileCsv,
  PiFileZip,
  PiFileVideo,
  PiFileAudio,
  PiFileText,
} from 'react-icons/pi'

/**
 * Map a document's file extension to its Phosphor file-type glyph (PDF / PNG /
 * spreadsheet / …) so a document row shows what kind of file it is at a glance,
 * instead of a generic doc icon. Falls back to the generic `PiFileText`.
 */
export function documentIcon(extension?: string | null): IconType {
  switch ((extension ?? '').toLowerCase().replace(/^\./, '')) {
    case 'pdf':
      return PiFilePdf
    case 'png':
      return PiFilePng
    case 'jpg':
    case 'jpeg':
      return PiFileJpg
    case 'gif':
    case 'webp':
    case 'svg':
    case 'bmp':
    case 'heic':
    case 'tiff':
      return PiFileImage
    case 'doc':
    case 'docx':
      return PiFileDoc
    case 'xls':
    case 'xlsx':
      return PiFileXls
    case 'ppt':
    case 'pptx':
      return PiFilePpt
    case 'csv':
      return PiFileCsv
    case 'zip':
    case 'rar':
    case '7z':
      return PiFileZip
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'webm':
      return PiFileVideo
    case 'mp3':
    case 'wav':
    case 'm4a':
      return PiFileAudio
    default:
      return PiFileText
  }
}
